export default __webpack_public_path__ + "static/media/bg.5c875ab8.jpg";